﻿import AttachmentType from "../enums/AttachmentType";

export default function countAttachments(attachments: Partial<Record<AttachmentType, FileList>> | undefined): number {
	if (attachments == null) return 0;
	let count = 0;
	for (const fileList of Object.values(attachments)) {
		if (fileList == null || fileList.length == 0) {
			continue;
		}

		if (fileList.length == 1) {
			count++;
		} else {
			count += fileList.length + 1;
		}
	}

	return count;
}
